// General
export const RESET = "RESET";

// Alerts
export const ADD_ALERT = "ADD_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const CLEAR_ALL_ALERTS = "CLEAR_ALL_ALERTS";

// Current user
export const LOGIN_MESSAGE = "LOGIN_MESSAGE";
export const SET_USER = "SET_USER";
export const SET_USER_CONTRACTS_LOADING = "SET_USER_CONTRACTS_LOADING";
export const SET_USER_CONTRACTS_TRIALS = "SET_USER_CONTRACTS_TRIALS";
export const SET_USER_TRIALS_LOADING = "SET_USER_TRIALS_LOADING";
export const SET_USER_CONTRACTS_TRIALS_LOADING =
  "SET_USER_CONTRACTS_TRIALS_LOADING";
export const SET_USER_CONTRACTS = "SET_USER_CONTRACTS";
export const SET_USER_TRIALS = "SET_USER_TRIALS";
export const SET_CONTRACT_PREFERENCES = "SET_CONTRACT_PREFERENCES";
export const SET_USER_SIDEBAR_COLLAPSE = "SET_USER_SIDEBAR_COLLAPSE";
export const RESET_USER_CONTRACTS_TRIALS = "RESET_USER_CONTRACTS_TRIALS";

// Mission monitoring (cached per campaign, reused across campaign/site pages)
export const SET_MISSIONS_MONITORING = "SET_MISSIONS_MONITORING";
export const SET_MISSIONS_MONITORING_LOADING =
  "SET_MISSIONS_MONITORING_LOADING";

// Users admin
export const SET_USERS = "SET_USERS";
export const USER_UPDATE_ALERT = "USER_UPDATE_ALERT";

// Companies admin
export const SET_COMPANIES = "SET_COMPANIES";
export const COMPANY_UPDATE_ALERT = "COMPANY_UPDATE_ALERT";

// Groups admin

// Contract - Sites admin
export const RESET_SITES = "RESET_SITES";
export const SET_SITES = "SET_SITES";
export const SITE_UPDATE_ALERT = "SITE_UPDATE_ALERT";
export const SITE_DISPATCH_DELETION = "SITE_DISPATCH_DELETION";
export const SET_SITE_TRIAL = "SET_SITE_TRIAL";
export const SET_REFRESHING_SITE_TRIAL = "SET_REFRESHING_SITE_TRIAL";
export const RESET_SITE_TRIAL = "RESET_SITE_TRIAL";

// Traits admin
export const SET_TRAITS = "SET_TRAITS";
export const TRAIT_UPDATE_ALERT = "TRAIT_UPDATE_ALERT";

// Data table (prefixes)
export const REFRESHING = "REFRESHING";
export const SET_SORT_PARAMS = "SET_SORT_PARAMS";

// Company
export const SET_COMPANY_CONTRACTS = "SET_COMPANY_CONTRACTS";
export const RESET_COMPANY = "RESET_COMPANY";
export const RESET_COMPANY_CONTRACTS = "RESET_COMPANY_CONTRACTS";
export const COMPANY_CONTRACT_UPDATE_ALERT = "COMPANY_CONTRACT_UPDATE_ALERT";

// ResultMap
export const SET_SELECTED_PLOT_ID = "SET_SELECTED_PLOT_ID";
export const SET_RESULT_MAP_FEATURES = "SET_RESULT_MAP_FEATURES";
export const RESET_RESULT_MAP = "RESET_RESULT_MAP";
export const REFRESHING_RESULT_MAP = "REFRESHING_RESULT_MAP";
export const FULL_RESET_RESULT_MAP = "FULL_RESET_RESULT_MAP";
export const CLEAR_RESULT_MAP_SITE = "CLEAR_RESULT_MAP_SITE";
export const SET_SELECTED_TRAIT = "SET_SELECTED_TRAIT";
export const SET_COLOR_SCALE_STEP = "SET_COLOR_SCALE_STEP";
export const SET_SCOUTING_COLOR_SCALE_STEP = "SET_SCOUTING_COLOR_SCALE_STEP";
export const SET_FEATURES_BY_DATE = "SET_FEATURES_BY_DATE";
export const REFRESHING_FEATURES_BY_DATE = "REFRESHING_FEATURES_BY_DATE";
export const FEATURES_BY_DATE_FAILED = "FEATURES_BY_DATE_FAILED";
export const SET_EXPERIMENTS_FILTER = "SET_EXPERIMENTS_FILTER";
export const SET_MODALITIES_FILTER = "SET_MODALITIES_FILTER";
export const SET_LAYER_FILTER = "SET_LAYER_FILTER";
export const SET_ATTRIBUTES_FILTER = "SET_ATTRIBUTES_FILTER";
export const CREATE_FILTERING_PROFILE = "CREATE_FILTERING_PROFILE";
export const DELETE_FILTERING_PROFILE = "DELETE_FILTERING_PROFILE";
export const SET_FILTERING_PROFILE = "SET_FILTERING_PROFILE";
export const SET_FILTERING_PROFILES = "SET_FILTERING_PROFILES";
export const SET_FILTERING_PROFILE_SCOPE = "SET_FILTERING_PROFILE_SCOPE";
export const UPDATE_FILTERING_PROFILE = "UPDATE_FILTERING_PROFILE";
export const SET_FILTERING_PROFILE_FILTER = "SET_FILTERING_PROFILE_FILTER";
export const SET_NEW_FEATURE_PROPERTIES = "SET_NEW_FEATURE_PROPERTIES";
export const DELETE_FILTERING_PROFILE_FILTER =
  "DELETE_FILTERING_PROFILE_FILTER";
export const RESET_FILTERING_PROFILE = "RESET_FILTERING_PROFILE";
export const ADD_GROUP_TO_FILTERING_PROFILE_BLACKLIST =
  "ADD_GROUP_TO_FILTERING_PROFILE_BLACKLIST";
export const REMOVE_GROUP_FROM_FILTERING_PROFILE_BLACKLIST =
  "REMOVE_GROUP_FROM_FILTERING_PROFILE_BLACKLIST";
export const ADD_GROUP_TO_FILTERING_PROFILE_WHITELIST =
  "ADD_GROUP_TO_FILTERING_PROFILE_WHITELIST";
export const REMOVE_GROUP_FROM_FILTERING_PROFILE_WHITELIST =
  "REMOVE_GROUP_FROM_FILTERING_PROFILE_WHITELIST";
export const SET_FOCUSED_VARIETIES = "SET_FOCUSED_VARIETIES";
export const REMOVE_FOCUSED_VARIETY = "REMOVE_FOCUSED_VARIETY";
export const SET_FAVORITE_VARIETIES = "SET_FAVORITE_VARIETIES";
export const SET_VISUALIZED_VARIETIES = "SET_VISUALIZED_VARIETIES";
export const SET_SELECTED_CONTRACT = "SET_SELECTED_CONTRACT";
export const SET_AUC_DATA = "SET_AUC_DATA";
export const REMOVE_TRAIT_FROM_AUC_DATA = "REMOVE_TRAIT_FROM_AUC_DATA";
export const UPSERT_MAP_LAYER = "UPSERT_MAP_LAYER";
export const SET_MAP_MODE = "SET_MAP_MODE";
export const SET_SCOUTING_FEATURES = "SET_SCOUTING_FEATURES";
export const SET_SCOUTING_DATES = "SET_SCOUTING_DATES";
export const SET_SELECTED_SCOUTING_FEATURE = "SET_SELECTED_SCOUTING_FEATURE";
export const RESET_SCOUTING = "RESET_SCOUTING";
export const ADD_ANOVA = "ADD_ANOVA";
export const ADD_TUKEY = "ADD_TUKEY";
export const SET_SELECTED_ANOVA_INDEX = "SET_SELECTED_ANOVA_INDEX";
export const RESET_ANOVA = "RESET_ANOVA";
export const UPDATE_TRIAL = "UPDATE_TRIAL";
export const SET_TRIAL_EXPERIMENT_STATUS = "SET_TRIAL_EXPERIMENT_STATUS";
export const SET_MAP_DISPLAY_MODE = "SET_MAP_DISPLAY_MODE";
export const SET_SELECTED_ATTRIBUTE = "SET_SELECTED_ATTRIBUTE";
export const SET_PENDING_FIELD_BOOK_COLORS = "SET_PENDING_FIELD_BOOK_COLORS";
export const SET_PLOT_LABEL_PROPERTY = "SET_PLOT_LABEL_PROPERTY";
export const SET_PLOT_LABEL_OPACITY = "SET_PLOT_LABEL_OPACITY";
export const SET_PLOT_LABELS_VISIBLE = "SET_PLOT_LABELS_VISIBLE";
export const SET_PLOT_MAP_COLORING = "SET_PLOT_MAP_COLORING";
export const SET_PLOT_MAP_OPACITY = "SET_PLOT_MAP_OPACITY";
export const SET_LINEAR_RULER_ACTIVE = "SET_LINEAR_RULER_ACTIVE";
export const SET_MENU_MAP_MODE = "SET_MENU_MAP_MODE";
export const SET_SCOUTING_TRAITS = "SET_SCOUTING_TRAITS";
export const SET_SELECTED_SCOUTING_TRAIT = "SET_SELECTED_SCOUTING_TRAIT";

// Crop
export const SET_CROPS = "SET_CROPS";
export const ADD_NEW_CROP = "ADD_NEW_CROP";
export const UPDATE_CROP = "UPDATE_CROP";
export const DELETE_CROP = "DELETE_CROP";

// Experiment
export const SET_SITE_EXPERIMENTS = "SET_EXPERIMENT";
// Modality
export const SET_SITE_MODALITIES = "SET_MODALITIES";

// Status Filter
export const SET_FILTER_BY_STATUS_MODE = "SET_FILTER_BY_STATUS_MODE";
export const RESET_FILTER_BY_STATUS = "RESET_FILTER_BY_STATUS";
export const ENABLE_EDITION_MODE = "ENABLE_EDITION_MODE";
